var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPushNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.2c-3.2 0-5.4 2.4-5.4 5.4 0 4.2-1.4 5.4-2 6.1-.2.3 0 .7.4.7h14c.4 0 .6-.4.4-.7-.6-.7-2-1.9-2-6.1 0-3-2.2-5.4-5.4-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 18.3c.3.9 1 1.5 1.8 1.5s1.5-.6 1.8-1.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPushNoti);
export default __webpack_public_path__ + "static/media/ic-push-noti.b39cf014cb8aba5f060883331e93e119.svg";
export { ForwardRef as ReactComponent };